// Der ehrliche Streifen.
//
// Ohne ihn wäre die App offline stumm: Sie zeigt weiter die Tour von vorhin,
// nichts lädt nach, Abhaken tut nichts — und der Fahrer weiß nicht, warum.
// Genau dieses stille Danebenstehen ist es, was eine Webseite von einer App
// unterscheidet.
//
// Er liegt über dem Inhalt statt in der Zeile, damit er beim Auftauchen nichts
// verschiebt. Ein Sprung im Layout mitten beim Tippen ist schlimmer als kein
// Hinweis.
//
// Er hängt bewusst GANZ oben in der App und nicht in der CRM-Shell: Wer die App
// ohne Netz öffnet und ausgeloggt ist, steht sonst vor einer Login-Maske, die
// einfach nicht funktioniert — ohne einen Hinweis, woran es liegt. Er würde sein
// Passwort für falsch halten.

import { useOffline, useNachNetzAktualisieren } from "@/lib/offline";

export function OfflineStreifen() {
  const offline = useOffline();
  useNachNetzAktualisieren();

  if (!offline) return null;

  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 top-[env(safe-area-inset-top)] z-[100] flex justify-center px-4 pt-2"
    >
      {/* warn-bg/warn-fg statt eines beliebigen Tailwind-Gelbs: die Paare sind
          in beiden Themes auf Kontrast geprüft. */}
      <div className="flex items-center gap-2 rounded-full border border-warn-fg/25 bg-warn-bg px-3.5 py-1.5 text-sm font-medium text-warn-fg shadow-lg">
        <span className="h-2 w-2 shrink-0 animate-pulse rounded-full bg-warn-fg" />
        Kein Netz — Daten sind nicht aktuell
      </div>
    </div>
  );
}
